<script setup>
/**
 * The opening block every marketing page shares: eyebrow, title, one paragraph,
 * and whatever actions the page needs.
 *
 * Having one component rather than four hand-built headers is what keeps the
 * pages feeling like one site — the rhythm above the fold is identical
 * everywhere, so only the words change.
 */
defineProps({
  eyebrow: { type: String, default: '' },
  title: { type: String, required: true },
  lead: { type: String, default: '' },
})
</script>

<template>
  <section class="relative overflow-hidden border-b border-line bg-surface-2">
    <!-- A single soft brand wash. Decorative, so it is hidden from assistive
         technology and sits behind the content rather than tinting it. -->
    <div
      class="pointer-events-none absolute -right-24 -top-32 size-96 rounded-full bg-brand-soft opacity-70 blur-3xl"
      aria-hidden="true"
    ></div>

    <div class="container-page relative py-14 md:py-20">
      <p v-if="eyebrow" class="text-xs font-extrabold uppercase tracking-[0.18em] text-brand">
        {{ eyebrow }}
      </p>
      <h1 class="mt-3 max-w-3xl text-3xl leading-[1.1] md:text-5xl">{{ title }}</h1>
      <p v-if="lead" class="mt-5 max-w-2xl text-lg leading-relaxed text-muted">{{ lead }}</p>

      <div v-if="$slots.actions" class="mt-8 flex flex-wrap gap-3">
        <slot name="actions" />
      </div>

      <slot />
    </div>
  </section>
</template>
